import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Spinner,
  Alert,
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import {
  FaUser,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaUserPlus,
  FaTruck,
} from "react-icons/fa";
import axios from "../../containers/api"; // ← مسیر رو چک کن
import logoImg from "../../assets/img/login.png"; // ← مسیر رو چک کن
import "./login.scss"; // ← فایل SCSS کنار همین فایل

const Login = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [initialUsername, setInitialUsername] = useState("");

  // بازیابی نام کاربری ذخیره شده
  useEffect(() => {
    const savedUsername = localStorage.getItem("savedUsername");
    const remember = localStorage.getItem("rememberMe");
    if (remember === "true" && savedUsername) {
      setInitialUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  // اعتبارسنجی با Yup
  const validationSchema = Yup.object({
    username: Yup.string()
      .required("نام کاربری الزامی است")
      .min(3, "نام کاربری حداقل ۳ کاراکتر باید باشد")
      .max(50, "نام کاربری حداکثر ۵۰ کاراکتر")
      .matches(/^[a-zA-Z0-9_\u0600-\u06FF]+$/, "نام کاربری معتبر نیست"),
    password: Yup.string()
      .required("رمز عبور الزامی است")
      .min(6, "رمز عبور حداقل ۶ کاراکتر باید باشد")
      .max(50, "رمز عبور حداکثر ۵۰ کاراکتر"),
  });

  const initialValues = {
    username: initialUsername || "",
    password: "",
  };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  const login = async (values) => {
    setLoading(true);
    setShowError(false);

    try {
      const postData = {
        Username: values.username.trim(),
        Password: values.password,
      };

      const res = await axios.post("/api/v1/User/login", postData);

      if (res.status === 200 && res.data.statusCode === 200 && res.data.data) {
        localStorage.setItem("jwt", res.data.data.accessToken);
        localStorage.setItem("member", JSON.stringify(res.data.data.member));
        localStorage.setItem("loggedIn", "true");

        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
          localStorage.setItem("savedUsername", values.username);
        } else {
          localStorage.removeItem("rememberMe");
          localStorage.removeItem("savedUsername");
        }

        setTimeout(() => {
          window.location.href = "/";
        }, 400);
      } else {
        const errorMsg =
          res.data.errors ||
          res.data.message ||
          "اطلاعات وارد شده صحیح نمی‌باشد";
        setErrorMessage(errorMsg);
        setShowError(true);
      }
    } catch (error) {
      let errorMsg = "خطا در ارتباط با سرور! لطفاً مجدداً تلاش کنید.";

      if (error.response) {
        errorMsg =
          error.response.data?.message ||
          error.response.data?.errors ||
          "خطا در ارتباط با سرور!";
      } else if (error.request) {
        errorMsg = "به سرور متصل نمی‌شود! اتصال اینترنت خود را بررسی کنید.";
      }

      setErrorMessage(errorMsg);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const onUserLogin = (values, { setSubmitting }) => {
    if (values.username && values.password && !loading) {
      login(values);
    }
    setSubmitting(false);
  };

  return (
    <div className="login-page-wrapper">
      <div className="bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <Row className="login-row justify-content-center align-items-center">
        <Col xs="12" sm="10" md="8" lg="6" xl="5">
          <Card className="login-card shadow-lg">
            <CardBody className="login-card-body">
              <div className="login-logo-container">
                <div className="logo-wrapper">
                  <img
                    src={logoImg}
                    alt="Bazargah Logo"
                    className="login-logo"
                    loading="lazy"
                  />
                </div>
                {/* <h3 className="brand-name">بازارگاه</h3> */}
              </div>

              <div className="login-header">
                <h2 className="login-title">خوش آمدید 👋</h2>
                <p className="login-subtitle">
                  برای ورود به پنل کاربری اطلاعات خود را وارد کنید
                </p>
              </div>

              {showError && (
                <Alert
                  color="danger"
                  className="login-alert"
                  toggle={() => setShowError(false)}
                  fade={true}
                >
                  <div className="d-flex align-items-center">
                    <span className="alert-icon">⚠️</span>
                    <span className="alert-text">{errorMessage}</span>
                  </div>
                </Alert>
              )}

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onUserLogin}
                enableReinitialize={true}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form className="login-form">
                    <div className="form-group">
                      <label className="form-label" htmlFor="username">
                        <FaUser className="label-icon" />
                        نام کاربری
                      </label>
                      <InputGroup className="login-input-group">
                        <InputGroupText className="input-icon">
                          <FaUser />
                        </InputGroupText>
                        <Field
                          name="username"
                          id="username"
                          type="text"
                          className={`form-control login-input ${
                            errors.username && touched.username
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="نام کاربری خود را وارد کنید"
                          autoComplete="username"
                          dir="ltr"
                        />
                      </InputGroup>
                      <ErrorMessage
                        name="username"
                        component="div"
                        className="error-message"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="password">
                        <FaLock className="label-icon" />
                        رمز عبور
                      </label>
                      <InputGroup className="login-input-group">
                        <InputGroupText className="input-icon">
                          <FaLock />
                        </InputGroupText>
                        <Field
                          name="password"
                          id="password"
                          type={showPassword ? "text" : "password"}
                          className={`form-control login-input ${
                            errors.password && touched.password
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="رمز عبور خود را وارد کنید"
                          autoComplete="current-password"
                          dir="ltr"
                        />
                        <InputGroupText
                          className="password-toggle"
                          onClick={toggleShowPassword}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </InputGroupText>
                      </InputGroup>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="error-message"
                      />
                    </div>

                    <div className="login-options">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                          className="checkbox-input"
                        />
                        <span className="checkbox-text">مرا به خاطر بسپار</span>
                      </label>
                      <Button
                        color="link"
                        className="forgot-password-btn"
                        onClick={() => history.push("/forgot-password")}
                      >
                        رمز را فراموش کرده‌ام؟
                      </Button>
                    </div>

                    <Button
                      type="submit"
                      color="success"
                      block
                      className="login-submit-btn"
                      disabled={loading || isSubmitting}
                    >
                      {loading || isSubmitting ? (
                        <>
                          <Spinner size="sm" className="me-2" color="light" />
                          در حال ورود...
                        </>
                      ) : (
                        "ورود به حساب کاربری"
                      )}
                    </Button>

                    <div className="divider">
                      <span className="divider-text">یا</span>
                    </div>

                    <div className="register-buttons-wrapper">
                      <Button
                        color="primary"
                        className="register-btn register-btn-owner"
                        onClick={() => history.push("/newregister")}
                      >
                        <FaUserPlus className="btn-icon" />
                        ثبت نام صاحب کالا
                      </Button>
                      <Button
                        color="warning"
                        className="register-btn register-btn-driver"
                        onClick={() => history.push("/newregisterdriver")}
                      >
                        <FaTruck className="btn-icon" />
                        ثبت نام راننده
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
